/**
 * 判断当前设备是否为移动端（手机 + 平板）
 * @returns {boolean} true=移动端，false=非移动端
 */
export function checkIsMobile() {
  // 若浏览器不支持navigator.userAgent（极少数情况），直接返回false
  if (!navigator || !navigator.userAgent) return false;

  const mobileRegex =
    /iPhone|iPad|iPod|Android|Mobile|BlackBerry|IEMobile|Opera Mini|Windows Phone/i;

  // 测试UA字符串是否包含移动端关键词
  return mobileRegex.test(navigator.userAgent);
}
